import * as React from "react";
const SvgFiRrPlantWilt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-plant-wilt_svg__a)">
      <path
        fill="#062147"
        d="M20.994 12.125C20.857 7.613 18.245 6 16 6a4.6 4.6 0 0 0-3 1.102V6.5C13 1.702 10.307 0 8 0 5.755 0 3.143 1.614 3.006 6.125A4.01 4.01 0 0 0 0 10c0 1.742 1.107 3.804 2.055 5.04.468.61 1.177.96 1.945.96s1.478-.35 1.945-.96C6.893 13.804 8 11.742 8 10a4.01 4.01 0 0 0-2.994-3.872C5.139 2.305 7.318 2 8 2c.704 0 3 .325 3 4.5V23a1 1 0 0 0 2 0V12.5C13 8.325 15.296 8 16 8c.682 0 2.861.305 2.994 4.128A4.01 4.01 0 0 0 16 16c0 1.742 1.107 3.804 2.055 5.04.468.61 1.177.96 1.945.96s1.478-.35 1.945-.96C22.893 19.804 24 17.742 24 16a4.01 4.01 0 0 0-3.006-3.875M6 10c0 1.104-.826 2.759-1.642 3.823A.44.44 0 0 1 4 14a.44.44 0 0 1-.358-.177C2.826 12.759 2 11.104 2 10s.897-2 2-2 2 .897 2 2m14.358 9.823A.44.44 0 0 1 20 20a.44.44 0 0 1-.358-.177C18.826 18.759 18 17.104 18 16s.897-2 2-2 2 .897 2 2-.826 2.759-1.642 3.823"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-plant-wilt_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPlantWilt;
